export default "__VITE_ASSET__DiO__bb5__";